import { BasePageComponent } from "@/components/base/BasePageComponent";
import { AppConstants } from "@/helpers/app.constants";
import { ActionService } from "@/services/action.service";
import { NavService } from "@/services/nav.service";
import { Component, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { ActivatedRoute } from "@angular/router";
import { PageTitleComponent } from "../../components/page-title/page-title.component";

@Component({
  selector: "app-help",
  templateUrl: "./help.component.html",
  styleUrls: ["./help.component.scss"],
  standalone: true,
  imports: [PageTitleComponent, MatButtonModule, MatExpansionModule],
})
export class HelpComponent extends BasePageComponent implements OnInit {
  helpArticleId: string;
  constructor(
    protected route: ActivatedRoute,
    protected navService: NavService,
    private actionService: ActionService
  ) {
    super(route, navService);
  }

  ngOnInit() {
    this.helpArticleId =
      this.route.snapshot.queryParams[AppConstants.PARAM_BEACON_ARTICLE_ID];
    if (this.helpArticleId) {
      this.actionService.showBeaconArticle(this.helpArticleId);
    }
  }
}
